import { Expose } from "class-transformer";
import { IsNotEmpty, IsUUID } from "class-validator";

export class FindOneLeadRankConfigInput {
  @Expose()
  @IsUUID()
  @IsNotEmpty()
  id: string;
}
